import Vue from 'vue'
import Router from 'vue-router'
import NotFound from './views/NotFound.vue'
import Login from './views/Login.vue'
import Page from './views/Page.vue'
import Settings from './views/Settings.vue'
import Track from './views/Track.vue'
import Calendar from './views/track/Calendar.vue'
import Rate from './views/track/Rate.vue'
import Summary from './views/track/Summary.vue'
import Trend from './views/track/Trend.vue'
import Checklist from './views/Checklist.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/404',
      component: NotFound },
    {
      path: '*',
      redirect: '/404'
    },
    { path: '/', redirect: 'page/prevent' },
    {
      path: '/page/*',
      name: 'page',
      component: Page,
      props: true
    },
    {
      path: '/track/track',
      name: 'track',
      component: Track,
      props: true
    },
    {
      path: '/track/calendar/:id',
      name: 'calendar',
      component: Calendar,
      props: true
    },
    {
      path: '/track/rate/:id/:date',
      name: 'rate',
      component: Rate,
      props: true
    },
    {
      path: '/track/summary/:id/:date',
      name: 'summary',
      component: Summary,
      props: true
    },
    {
      path: '/track/trend/:id',
      name: 'trend',
      component: Trend,
      props: true
    },
    {
      path: '/settings/:id',
      name: 'settings',
      component: Settings,
      props: true
    },
    {
      path: '/checklist',
      name: 'checklist',
      component: Checklist,
      props: true
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }
  ]
})
